<template>
  <div class="header">
    <template v-if="isPc">
      <!-- 层1: 顶部工具条 -->
      <div class="top-bar">
        <div class="wrap">
          <div class="top-bar-inner">
            <div class="top-left">
              <span class="top-welcome">欢迎访问 鲁凝教育 · 二级建造师继续教育在线学习平台</span>
              <span class="top-weather" v-if="weatherText">{{ weatherText }}</span>
            </div>
            <div class="top-right">
              <a href="#" class="top-link">帮助中心</a>
              <a href="#" class="top-link">学习指南</a>
              <a href="#" class="top-link">常见问题</a>
              <a href="#" class="top-link">联系我们</a>
              <span class="top-sep">|</span>
              <template v-if="!isLOgin">
                <span class="top-link" @click="goLogin">登录</span>
                <span class="top-link top-register" @click="goRegister">免费注册</span>
              </template>
              <template v-else>
                <span class="top-link top-user">{{ realName || name }}</span>
                <span class="top-link" @click="goLogout">退出</span>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- 层2: 品牌区 -->
      <div class="brand-bar">
        <div class="wrap">
          <div class="brand-inner">
            <div class="brand-logo" @click="goHome">
              <div class="brand-text">
                <div class="brand-main">
                  <span class="brand-title">鲁凝教育 · 二级建造师继续教育学习平台</span>
                </div>
                <div class="brand-en">CONSTRUCTOR CONTINUING EDUCATION ONLINE LEARNING PLATFORM</div>
              </div>
            </div>

            <div class="brand-actions">
              <button class="btn-buy" v-if="isLOgin" @click="goAllSubject">课程购买</button>
              <button class="btn-learning" @click="goMySubject">立即学习 →</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 层3: 导航栏 -->
      <div class="nav-bar">
        <div class="wrap">
          <div class="nav-inner">
            <div
              v-for="item in navList"
              :key="item.path"
              :class="['nav-item', { active: isActive(item) }]"
              @click="handleNavClick(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- 移动端 -->
    <template v-else>
      <nav class="mobile-navbar">
        <div class="mobile-nav-inner">
          <div class="mobile-brand" @click="goHome">鲁凝教育 · 二级建造师继续教育</div>
          <button class="mobile-toggler" @click="mobileMenuOpen = !mobileMenuOpen">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#1565C0" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
            </svg>
          </button>
        </div>
        <div v-if="mobileMenuOpen" class="mobile-menu">
          <div v-for="item in navList" :key="item.path" :class="['mobile-menu-item', { active: isActive(item) }]" @click="handleMobileNavClick(item)">
            {{ item.name }}
          </div>
          <template v-if="!isLOgin">
            <div class="mobile-menu-item" @click="goLogin">登录</div>
            <div class="mobile-menu-item" @click="goRegister">免费注册</div>
          </template>
          <template v-else>
            <div class="mobile-menu-item" @click="goProfile">个人中心</div>
            <div class="mobile-menu-item" @click="goLogout">退出登录</div>
          </template>
        </div>
      </nav>
    </template>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "project-header",
  data() {
    return {
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      mobileMenuOpen: false,
      weatherText: "",
      navList: [
        { name: "网站首页", path: "/" },
        { name: "我的课程", path: "/mySubject" },
        { name: "通知公告", path: "/noticeList" },
        { name: "学时查询", path: "/mySubject", query: { tab: "record" } },
        { name: "个人中心", path: "/profile" },
      ],
    };
  },
  computed: {
    isLOgin: function () { return getToken(); },
    isPc: function () { return window.innerWidth > 768; },
    ...mapGetters(["name", "realName"]),
  },
  watch: { "$route"() { this.mobileMenuOpen = false; } },
  mounted() {
    this.fetchWeather();
  },
  methods: {
    async fetchWeather() {
      try {
        // 1. 根据 IP 获取城市
        const geoRes = await fetch("https://api.ip.sb/geoip");
        const geoData = await geoRes.json();
        const cityEn = geoData.city || "";
        if (!cityEn) return;
        // 城市名翻译
        const cityMap = {
          "Jinan": "济南", "Beijing": "北京", "Shanghai": "上海", "Guangzhou": "广州",
          "Shenzhen": "深圳", "Hangzhou": "杭州", "Nanjing": "南京", "Wuhan": "武汉",
          "Chengdu": "成都", "Chongqing": "重庆", "Xi'an": "西安", "Zhengzhou": "郑州",
          "Changsha": "长沙", "Hefei": "合肥", "Fuzhou": "福州", "Xiamen": "厦门",
          "Nanchang": "南昌", "Kunming": "昆明", "Guiyang": "贵阳", "Nanning": "南宁",
          "Lanzhou": "兰州", "Xining": "西宁", "Yinchuan": "银川", "Urumqi": "乌鲁木齐",
          "Hohhot": "呼和浩特", "Harbin": "哈尔滨", "Changchun": "长春", "Shenyang": "沈阳",
          "Tianjin": "天津", "Shijiazhuang": "石家庄", "Taiyuan": "太原", "Haikou": "海口",
          "Qingdao": "青岛", "Suzhou": "苏州", "Dalian": "大连", "Ningbo": "宁波",
          "Wuxi": "无锡", "Foshan": "佛山", "Dongguan": "东莞", "Zhuhai": "珠海",
        };
        const city = cityMap[cityEn] || cityEn;
        // 2. 获取天气
        const weatherRes = await fetch(
          `https://wttr.in/${encodeURIComponent(cityEn)}?format=j1`
        );
        const weatherData = await weatherRes.json();
        const cur = weatherData.current_condition[0];
        const conditionEn = cur.weatherDesc[0].value;
        const condition = this.translateWeather(conditionEn);
        const temp = cur.temp_C + "℃";
        this.weatherText = city + " " + condition + " " + temp;
      } catch (e) {
        this.weatherText = "";
      }
    },
    translateWeather(en) {
      const map = {
        "Sunny": "晴", "Clear": "晴",
        "Partly cloudy": "多云", "Partly Cloudy": "多云",
        "Cloudy": "阴", "Overcast": "阴",
        "Mist": "雾", "Fog": "雾", "Haze": "霾",
        "Light rain": "小雨", "Light Rain": "小雨",
        "Moderate rain": "中雨", "Moderate Rain": "中雨",
        "Heavy rain": "大雨", "Heavy Rain": "大雨",
        "Light snow": "小雪", "Light Snow": "小雪",
        "Moderate snow": "中雪", "Moderate Snow": "中雪",
        "Heavy snow": "大雪", "Heavy Snow": "大雪",
        "Thunderstorm": "雷阵雨", "Thundery outbreaks possible": "可能有雷雨",
        "Patchy rain possible": "局部阵雨", "Patchy light rain": "局部小雨",
      };
      return map[en] || en;
    },
    isActive(item) {
      const path = item.path;
      if (path === "/") return this.$route.path === "/";
      // 多个 nav 指向同一 path 时，只激活第一个，除非当前 item 匹配 query
      const firstIndex = this.navList.findIndex(n => {
        if (n.path === "/") return this.$route.path === "/";
        return this.$route.path.indexOf(n.path) === 0;
      });
      const currentIndex = this.navList.indexOf(item);
      // 如果当前有 query 匹配
      if (item.query && this.$route.path === item.path) {
        const queryMatch = Object.keys(item.query).every(k => this.$route.query[k] === String(item.query[k]));
        return queryMatch;
      }
      // 如果是同一个 path 的第一个（无 query 的），且当前路由没有匹配某个有 query 的
      if (firstIndex === currentIndex) {
        const hasQueryMatch = this.navList.some(n => n.query && this.$route.path === n.path
          && Object.keys(n.query).every(k => this.$route.query[k] === String(n.query[k])));
        return !hasQueryMatch;
      }
      return false;
    },
    goHome() { this.$router.push({ path: "/" }); },
    goProfile() {
      let routeData = this.$router.resolve({ name: "profile" });
      window.open(routeData.href, "_blank");
    },
    goLogin() { this.$router.push({ name: "Login" }); },
    goRegister() {
      let routeData = this.$router.resolve({ name: "register" });
      window.open(routeData.href, "_blank");
    },
    goMySubject() { this.$router.push({ path: "/mySubject" }); },
    goAllSubject() {
      this.$router.push({ path: "/mySubject", query: { tab: "buy" } });
    },
    goLogout() {
      sessionStorage.removeItem("loginAnnouncementShown");
      localStorage.removeItem("loginAnnouncementShown");
      this.$store.dispatch("user/logout");
      this.$message.success("退出成功");
    },
    handleNavClick(item) {
      if (item.path === "/profile") { this.goProfile(); return; }
      this.$router.push({ path: item.path, query: item.query || {} });
    },
    handleMobileNavClick(item) {
      this.handleNavClick(item);
      this.mobileMenuOpen = false;
    },
  },
};
</script>

<style scoped lang="scss">
// ====================== 顶部工具条 ======================
.top-bar {
  background: #f5f5f5;
  border-bottom: 1px solid #eee;
  height: 36px;
  font-size: 12px;
  color: #888;

  .top-bar-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 36px;
  }

  .top-left {
    display: flex;
    align-items: center;
    gap: 16px;

    .top-weather { color: #999; }
  }

  .top-right {
    display: flex;
    align-items: center;
    gap: 10px;

    .top-link {
      color: #666;
      cursor: pointer;
      text-decoration: none;
      &:hover { color: #1565C0; }
    }

    .top-register { color: #1565C0; font-weight: 500; }
    .top-user { color: #1565C0; font-weight: 500; }
    .top-sep { color: #ddd; }
  }
}

// ====================== 品牌区 ======================
.brand-bar {
  background: #fff;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
}

.brand-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand-logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex: 1;
  min-width: 0;

  .brand-text {
    min-width: 0;

    .brand-name {
      font-size: 13px;
      color: #1565C0;
      font-weight: 500;
      margin-bottom: 2px;
      letter-spacing: 1px;
    }

    .brand-main .brand-title {
      font-size: 28px;
      font-weight: 800;
      color: #0D47A1;
      letter-spacing: 2px;
    }

    .brand-en {
      font-size: 12px;
      color: #bbb;
      letter-spacing: 2px;
      margin-top: 4px;
    }
  }
}

.brand-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;

  .btn-learning {
    padding: 8px 24px;
    background: linear-gradient(135deg, #1565C0, #1976D2);
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    letter-spacing: 1px;
    white-space: nowrap;
    transition: all 0.3s;

    &:hover { background: linear-gradient(135deg, #0D47A1, #1565C0); }
  }

  .btn-buy {
    padding: 8px 24px;
    background: linear-gradient(135deg, #FF8F00, #FF6D00);
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.3s;
    box-shadow: 0 2px 8px rgba(255, 111, 0, 0.3);

    &:hover { background: linear-gradient(135deg, #FF6D00, #E65100); box-shadow: 0 4px 12px rgba(255, 111, 0, 0.4); }
  }
}

// ====================== 主导航 ======================
.nav-bar {
  background: linear-gradient(135deg, #0D47A1, #1565C0);
  height: 48px;
}

.nav-inner {
  display: flex;
  align-items: center;
  height: 48px;
  gap: 0;

  .nav-item {
    padding: 0 22px;
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    color: rgba(255,255,255,0.85);
    cursor: pointer;
    position: relative;
    white-space: nowrap;
    transition: all 0.2s;

    &:hover { background: rgba(255,255,255,0.1); color: #fff; }

    &.active {
      color: #fff;
      font-weight: 600;
      background: rgba(255,255,255,0.12);
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 60%;
        height: 2px;
        background: #fff;
      }
    }
  }
}

// ====================== 移动端 ======================
.mobile-navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.mobile-nav-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 52px;
}

.mobile-brand {
  font-size: 14px;
  font-weight: 600;
  color: #0D47A1;
  cursor: pointer;
}

.mobile-toggler {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.mobile-menu {
  background: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 8px 0;

  .mobile-menu-item {
    padding: 12px 24px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    &.active { color: #1565C0; font-weight: 600; background: #f5f8fc; }
    &:active { background: #f0f4ff; }
    &.mobile-menu-register { color: #1565C0; font-weight: 500; }
    &.mobile-menu-logout { color: #e53935; }
  }
}

@media (max-width: 600px) {
  .mobile-brand { font-size: 12px; }
}
</style>
